import { FileCsv } from '@phosphor-icons/react';

export default FileCsv;
